import Vue from "vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

import "./helpers";
import Root from "./Root.vue";
import "./vue/plugins/index";
import "./vue/filters/index";
import "./vue/prototypes/index";
import "./vue/globalComponents.js";
import "./assets/scss/index.scss";
import "./theme";
import router from "./router";
import store from "./store/store";
import "prismjs"; // PrismJS
import "prismjs/themes/prism-tomorrow.css";
require("./assets/scss/iconfont.scss"); // Feather font icon
import JsonExcel from "vue-json-excel";
import * as Sentry from "@sentry/vue";


Vue.config.productionTip = process.env.NODE_ENV === "production";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js")
    .then((registration) => {
      if (process.env.NODE_ENV === "development") console.log(registration);
    })
    .catch((err) => {
      if (process.env.NODE_ENV === "development") console.log(err);
    });
}

Vue.component("date-picker", VuePersianDatetimePicker);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

Vue.component("downloadExcel", JsonExcel);

Sentry.init({
  Vue,
  dsn: "https://3183d81f8921675a4b8357068a882604@o260579.ingest.us.sentry.io/4507480446730240",
  integrations: [],
});

new Vue({
  router,
  store,
  render: (h) => h(Root),
}).$mount("#app");
